<template>
  <q-card class="license-state-dialog-container center relative scroll">
    <div
      class="row items-center icon-container"
      style="padding: unset"
    >
      <img
        :src="License_exclamation_icon"
        alt="license-icon"
      />
    </div>
    <div>
      <div class="dialog-title text-center">
        {{ $t('generic.licenseStates.licenseMarketPlace.title') }}
      </div>
      <div class="dialog-description gordita-400-16-r text-center">
        <div
          :data-testid="elementsId.dialogs.licenseDialogs.licenseMarketplaceDialog.AWSLink"
          class="gordita-400-16-r"
        >
          {{ $t('generic.licenseStates.licenseMarketPlace.description') }}
          <a
            href=" https://aws.amazon.com/marketplace/pp/prodview-gaxjwt6msh55q?sr=0-1&ref_=beagle&applicationId=AWSMPContessa"
            class="link-font text-brand_almost_black"
            >AWS Marketplace</a
          >
        </div>
      </div>
    </div>
  </q-card>
</template>

<script>
import elementsId from '@/const/elementIds.json';
import { defineComponent } from 'vue';
import License_exclamation_icon from '../../../../assets/images/LicenseStatesDialogs/license-exclamation-icon.svg';
import { licenseDialogMixins } from './licenseDialogMixins';

export default defineComponent({
  name: 'LicenseMarketplaceDialog',
  mixins: [licenseDialogMixins],
  setup() {
    return {
      elementsId,
      License_exclamation_icon,
    };
  },
});
</script>

<style scoped lang="scss">
@import 'LicenseDialogsCommonStyle';
</style>
